import useRestaurantStore from "../stores/useRestaurantStore";

/**
 * prepareBillModificationGuard — TSK-3303.
 *
 * Once Prepare Bill has created a server-confirmed order (cart.preparedBillOrigin
 * === "Y"), every item-level cart mutation (add, qty change, delete, cancel/void,
 * discount, notes, addon repeat, production-center/sale-type reassignment, fire,
 * copy-KOT, ...) must be blocked unless the till explicitly opts in via
 * posConfig.allowModificationAfterPrepareBill === "Y". Centralized here so every
 * call site checks the same condition instead of re-deriving it.
 *
 * BUG-2620: the same block for a cart whose dine-in table had its bill prepared on ANOTHER
 * device (the waiter's cart never carries preparedBillOrigin). CartOrderSidebar's table lock
 * publishes that as tableName.billRequested in useRestaurantStore; it is never set for retail,
 * supermarket or take-away carts, and never for split tables (Prepare Bill marks only the
 * parent table, so one split's bill must not lock the others).
 */
export function isPrepareBillModificationBlocked(cart, posConfig) {
  if (posConfig?.allowModificationAfterPrepareBill === "Y") return false;
  if (cart?.preparedBillOrigin === "Y") return true;
  return isOpenTableBillRequested(cart);
}

/** BUG-2620: the cart's dine-in table (same table, same split) is open here with its bill prepared. */
export function isOpenTableBillRequested(cart) {
  if (!cart?.tableId) return false;
  const { dineIn, tableName } = useRestaurantStore?.getState?.() || {};
  return (
    dineIn === "Y" &&
    tableName?.billRequested === true &&
    tableName?.cwrFbTableId != null &&
    String(tableName.cwrFbTableId) === String(cart.tableId) &&
    (tableName.splitTable || null) === (cart.splitTable || null)
  );
}

export const PREPARE_BILL_MODIFICATION_BLOCKED_MESSAGE = "Bill is already prepared. Item modifications are not allowed.";
